import { pdfInputEmail } from '../../defaultStates'
import { SET_PDF_EMAIL } from '../../ActionTypes'

export default (state = pdfInputEmail, action = {}) => {
  switch (action.type) {
    case SET_PDF_EMAIL:
      return {
        inputEmail: action.inputEmail,
      }
    default:
      return state
  }
}
